import { apiClient } from 'api/apiClient';
import type { IApiResponse } from 'api/apiTypes';
import type {
	TInvoiceStatuses,
	TPaymentMethods,
} from 'api/resources/overviews';

const RESOURCE = '/invoices';

export interface IInvoiceStatusPayload {
	id: string;
	status: TInvoiceStatuses;
	paymentMethod?: TPaymentMethods;
}

export type TPostInvoiceStatusResponse = IApiResponse<Record<string, string>>;

export const postInvoiceStatus = async (payload: IInvoiceStatusPayload[]) => {
	const { data } = await apiClient.patch(RESOURCE, {
		payload,
	});

	return data;
};
